import React, { memo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../common/constants.tsx';
import type { SaveResetViewSettingsButton$key } from './__generated__/SaveResetViewSettingsButton.graphql';
import { SaveResetViewSettingsButtonCollapsible } from './SaveResetViewSettingsButtonCollapsible.tsx';

type Props = {
	onReset: (onResetComplete: () => void) => void;
	onChangeJql?: (jql: string, clearFilter?: boolean) => void;
	viewFragment: SaveResetViewSettingsButton$key;
	jql: string;
};

export const SaveResetViewSettingsButton = memo(
	({ onReset, viewFragment, jql, onChangeJql }: Props) => {
		const viewMetadata = useFragment(
			graphql`
				fragment SaveResetViewSettingsButton on JiraIssueSearchViewMetadata {
					...SaveResetViewSettingsButtonCollapsible
				}
			`,
			viewFragment,
		);

		return (
			<JSErrorBoundary
				fallback="unmount"
				id="issue-navigator-save-reset-view-settings-button"
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
			>
				<SaveResetViewSettingsButtonCollapsible
					jql={jql}
					onReset={onReset}
					onChangeJql={onChangeJql}
					viewFragment={viewMetadata}
				/>
			</JSErrorBoundary>
		);
	},
);
